<div class="content-space">
  <div class="profiles">
    <div class="profile-card" *ngFor="let person of personList">
      <div class="image" [style]="{'background-image': 'url('+person.picture+')'}"></div>
      <div class="info">
        <div>
          <h2>{{person.name}}</h2>
          <div class="divider"></div>
          <p class="flex items-center" *ngIf="person.name === 'Meleghegyi Fanni' || person.name === 'Kaufer Barbara'" ><img src="assets/icons/mother.png" alt="doctor" width="20" />Munkatársunk szülési szabadságát tölti.</p>
          <p class="flex items-center pt-3"><img src="assets/icons/doctor.png" alt="doctor" width="20"/>{{person.job}}</p>
          <p><a [href]="'tel:' + person.mobileHref"><img src="assets/icons/phone.png" alt="phone" width="20"/>{{person.mobile}}</a>
          </p>
        </div>
        <a class="primary-button" routerLink="/munkatarsaink/{{person.url}}">Bemutatkozás</a>
      </div>
    </div>
  </div>
</div>
